import { buildPropsHelper } from './helpers/props';

export default {
  // This Hook may be used for events which you want to emit to parent component in case of nested components
  // e.g on-blur-event which is triggered from inner component to parent (not live view)
  EventPush: {
    ...buildPropsHelper(),

    mounted() {
      this.isDestroyed = false;
      this.eventPushedCallback = this.eventPushed.bind(this);
      this.initialize();
    },

    updated() {
      if (this.propsChanged()) {
        this.initialize();
      }
    },

    destroyed() {
      this.isDestroyed = true;
    },

    getProps() {
      return {
        triggerEventName: this.el.dataset.triggerEventName,
        triggeredEventName: this.el.dataset.triggeredEventName,
        eventTarget: this.el.dataset.eventTarget,
      };
    },

    initialize() {
      this.setProps();
      this.addEventListeners();
    },

    eventPushed(e) {
      if (this.triggerEventName) {
        const rootElement = this.el;
        const eventTarget = this.eventTarget;
        const triggerEventName = this.triggerEventName;
        const triggeredEventName = this.triggeredEventName;

        // NOTE: This is to ensure that all other internal callbacks are executed before this event
        setTimeout(() => {
          if (this.isDestroyed || !rootElement.isConnected) return;

          if (eventTarget) this.pushEventTo(eventTarget, triggeredEventName, { name: triggerEventName });
        }, 50);
      }
    },

    addEventListeners() {
      this.handleEvent(`${this.triggerEventName}`, e => {
        this.eventPushed(e);
      });
    },
  },
};
